import { ServerError } from '@apollo/client'
import { isObject } from './generics'

export const isServerError = <T = ServerError>(arg: any): arg is T => {
  return (
    isObject(arg) &&
    (arg?.name === 'ServerError' || arg?.name === 'ServerParseError')
  )
}

export const isError = (arg: unknown): arg is Error => arg instanceof Error
